// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router'; // no need for the router just comment or delete this line
import store from './store'; // no need for the store just comment or delete this line

// development configurations
Vue.config.productionTip = process.env.NODE_ENV !== 'production';
Vue.config.devtools = process.env.NODE_ENV !== 'production';

// http client
// import httpClient from 'axios';
// const http = httpClient.create();
// Vue.use(Vue => {
//   Vue.prototype.$http = http;
// });

// service client
import svcClient from '@/core/svc-client';
import svcUrl from '@/core/svc-url';
Vue.use(Vue => {
  Vue.prototype.$svc = svcClient;
  Vue.prototype.$svcUrl = svcUrl;
});

// Design System library
import '@deputy/dslibrary/library/index.css';
import { DSLibrary } from '@deputy/dslibrary';
Vue.use(DSLibrary);

// translation support
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import i18nBaseFileEnAu from '@/locales/en-AU.json';
// import i18nBaseFilePtBr from '@/locales/pt-BR.json';

Vue.use(VueI18Next);
i18next.init({
  // debug: true,
  lng: 'en-AU',
  ns: ['common'],
  defaultNS: 'common',
  resources: {
    'en-AU': i18nBaseFileEnAu,
    // 'pt-BR': i18nBaseFilePtBr,
  },
  fallbackLng: {
    default: ['en-AU'],
  },
});
const i18n = new VueI18Next(i18next);

// analytics client
// Vue.use(Vue => {
//   analytics.initialize(process.env.SEGMENT_KEY); // TODO: inject the key from the backend
//   Vue.prototype.$track = analytics.track;
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router, // no need for the router just comment or delete this line
  store, // no need for the store just comment or delete this line
  i18n,
  render: h => h(App),
});
